export const INSPECTION_QUESTIONS = [
  {
    key: "products_match_order",
    label: "Czy dostarczone produkty są zgodne z zamówieniem?",
    correct_answer: true,
  },
  {
    key: "packages_damaged",
    label: "Czy opakowania są uszkodzone?",
    correct_answer: false,
  },
  {
    key: "batch_markings_correct",
    label: "Czy oznaczenia partii są prawidłowe i czytelne?",
    correct_answer: true,
  },
  {
    key: "screws_damaged",
    label: "Czy wkręty mają uszkodzenia, odkształcenia lub korozje?",
    correct_answer: false,
  },
  {
    key: "delivery_acceptable",
    label: "Czy dostawa spełnia wymagania i może zostać przyjęta?",
    correct_answer: true,
  },
];

export const needsInspectionModal = (grn) =>
  Boolean(grn?.grn_inspection) && !grn.grn_inspection.confirmed_at;

export const isIncorrectAnswer = (question, answer) =>
  answer !== undefined && answer !== question.correct_answer;
